import { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { PublicLayout } from "./components/layout/PublicLayout";
import { Home } from "./pages/public/Home";
import { Schedule } from "./pages/public/Schedule";
import { Team } from "./pages/public/Team";
import { Pricing } from "./pages/public/Pricing";
import { Contact } from "./pages/public/Contact";
import { Reservation } from "./pages/public/Reservation";
import { Legal } from "./pages/public/Legal";
import { NotFound } from "./pages/public/NotFound";
import { AdminLayout } from "./components/admin/AdminLayout";
import { AdminLogin } from "./pages/admin/Login";
import { AdminDashboard } from "./pages/admin/Dashboard";
import { AdminLeads } from "./pages/admin/Leads";
import { AdminCoaches } from "./pages/admin/Coaches";
import { AdminSchedule } from "./pages/admin/Schedule";
import { AdminPricing } from "./pages/admin/Pricing";
import { AdminGyms } from "./pages/admin/Gyms";
import { AdminSettings } from "./pages/admin/Settings";
import { AdminAudit } from "./pages/admin/Audit";
import { PageviewTracker } from "./components/PageviewTracker";
import { EnvBanner } from "./components/EnvBanner";
import { ThemeProvider } from "./providers/ThemeProvider";

function ContactRoute() {
  const location = useLocation();
  return <Contact key={`${location.pathname}${location.search}`} />;
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    // On gère nous-mêmes le scroll : évite que le navigateur restaure une
    // ancienne position lors d'une navigation (surtout sur mobile).
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    // Après le paint : plus fiable sur mobile (barre d'URL iOS, contenu chargé
    // de façon asynchrone) qu'un scroll synchrone au moment de l'effet.
    const raf = requestAnimationFrame(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      if (document.body) document.body.scrollTop = 0;
    });
    return () => cancelAnimationFrame(raf);
  }, [pathname]);
  return null;
}

export function App() {
  return (
    <ThemeProvider>
      <ScrollToTop />
      <PageviewTracker />
      <EnvBanner />
      <Routes>
        <Route element={<PublicLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/plannings" element={<Navigate to="/plannings/brest" replace />} />
          <Route path="/plannings/:gym" element={<Schedule />} />
          <Route path="/equipe" element={<Team />} />
          <Route path="/tarifs" element={<Pricing />} />
          <Route path="/contact" element={<ContactRoute />} />
          <Route path="/reservation" element={<Navigate to="/reservation/brest" replace />} />
          <Route path="/reservation/:gym" element={<Reservation />} />
          <Route path="/mentions-legales" element={<Legal kind="mentions" />} />
          <Route path="/politique-confidentialite" element={<Legal kind="privacy" />} />
          <Route path="*" element={<NotFound />} />
        </Route>

        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<Navigate to="/admin/dashboard" replace />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="leads" element={<AdminLeads />} />
          <Route path="gyms" element={<AdminGyms />} />
          <Route path="coaches" element={<AdminCoaches />} />
          <Route path="schedule" element={<AdminSchedule />} />
          <Route path="pricing" element={<AdminPricing />} />
          <Route path="settings" element={<AdminSettings />} />
          <Route path="audit" element={<AdminAudit />} />
        </Route>
      </Routes>
    </ThemeProvider>
  );
}
